import { initClient } from 'rwsdk/client';
import './global.css';

initClient();
